import { useSelector } from 'react-redux';

import { IReduxState } from '../../types/redux';

export const useSearchText = <T>(defaultValue: T) =>
  useSelector((state: IReduxState) => state.searchRealtors.searchText) || defaultValue;

export const useSpecialistType = () => useSelector((state: IReduxState) => state.searchRealtors.specialistType);

export const useDealType = () => useSelector((state: IReduxState) => state.searchRealtors.dealType);

export const useOfferType = () => useSelector((state: IReduxState) => state.searchRealtors.offerType);
